import { getBanner } from "../Api";
export default {
    state: {
        banners: null
    },
    actions: {
        async fetchBanners({ commit }) {
            try {
                const respons = await getBanner();
                commit("SET_BANNERS", respons);
            } catch (error) {
                console.error(error);
            }
        }
    },
    mutations: {
        SET_BANNERS(state, content) {
            state.banners = content;
        }
    },
    getters: {
        getBanners(state) {
            return state.banners;
        }
    }
};
